module.exports = __webpack_public_path__ + "static/newsletter2go-d963f45a1c8fe55be5e566dea654b7ee.png";